import * as accountingOrdersCoordinators from './accountingOrders'

export default Object.freeze({
  ...accountingOrdersCoordinators,
})
